/*
 * @Descripttion:
 * @version:
 * @Author: 苏
 * @email: 1373842098@qq.com
 * @Date: 2022-11-14 11:43:22
 * @LastEditors: linxi
 * @LastEditTime: 2023-07-24 14:02:51
 */
import { Col, Rate, Row, Tooltip } from 'antd'
import React, { ReactElement, useEffect, useRef, useState } from 'react'
import {
  BoyIcon,
  GirlIcon,
} from '../../../../compnents/icons/Icons'
import styles from './unexecutedPrescription.module.css'
import moment from 'moment'
import { DateTimeFormatSimples } from '../../../../models/datetime'

interface PatientDetailMessageProps {
  detail?: any
}

export const PatientDetailMessage = ({
  detail,
}: PatientDetailMessageProps): ReactElement => {

  return (
    <>
      <div className={styles.panelHeader}>
        <Col
          span={6}
          className={styles.panelHeaderItem}
        >
          <Row>
            <Col className={styles.headerItemIcon}>
              {detail?.patientSex == 2 ? (
                <GirlIcon
                  style={{
                    width: 48,
                    height: 48,
                  }}
                />
              ) : <BoyIcon
                style={{
                  width: 48,
                  height: 48,
                }}
              />}
            </Col>
            <Col>
              <Col className={styles.headerItemName}>{detail?.patientName || '-'}
              </Col>
              <Col className={styles.headerItem}>病历号：{detail?.patientId || '-'}</Col>
            </Col>
          </Row>
        </Col>
        <Row
          style={{
            flex: 1,
          }}
        >
          <Col span={8} className={styles.headerItem}>
            <Col>诊断： {detail?.disease || '-'} </Col>
            <Col>年龄：{detail?.patientAge ? detail?.patientAge + '岁' : '-'} </Col>
          </Col>
          <Col span={8} className={styles.headerItem}>
            <Col>医生：{detail?.treatmentDoctorName || '-'} </Col>
            <Col>手机号：{detail?.patientPhone || '-'} </Col>
          </Col>
          <Col span={8} className={styles.headerItem}>
            <Col>就诊时间：{detail?.registrationTime ? moment(detail?.registrationTime).format(DateTimeFormatSimples) : '-'} </Col>
          </Col>
        </Row>
      </div>
    </>
  );
}
